module.exports = __webpack_public_path__ + "img/ic_plan_upgrade.01931048.png";